(function (angular) {
  /**
   * Service: lockApi
   */
  angular
    .module('acme.common.service.lockApi', ['acme.common.factory.apiVersion', 'acme.common.factory.QueryStringBuilder'])
    .service('LockApiService', LockApiService);

  LockApiService.$inject = ['$http', 'ApiVersionFactory', 'QueryStringBuilderFactory'];

  function LockApiService($http, ApiVersionFactory, QueryStringBuilderFactory) {
    return {
      service: '',

      init: function (endpoint) {
        this.service = endpoint + '/locks/lock';
        return this;
      },

      create: function (props) {
        var av = new ApiVersionFactory(),
          q = '';

        if (props && props.force) {
          q = '/force';
        }

        return $http({
          method: 'post',
          url: av.init({ url: this.service + '/' + props.type + '/' + props.id + q, version: 'v2' }),
          data: {},
        });
      },

      remove: function (props) {
        var av = new ApiVersionFactory(),
          q = '';

        if (props && props.force) {
          q = '/force';
        }

        return $http({
          method: 'delete',
          url: av.init({ url: this.service + '/' + props.type + '/' + props.id + q, version: 'v2' }),
        });
      },

      /**
       *
       * @param {{ type: 'EventTemplate'; ids: Array<string> }} props
       */
      createMany: function (props) {
        var self = this;

        return Promise.all(
          props.ids.map(function (id) {
            return self.create({ type: props.type, id: id });
          })
        );
      },

      /**
       *
       * @param {{ type: 'EventTemplate'; ids: Array<string> }} props
       */
      removeMany: function (props) {
        var self = this;

        return Promise.all(
          props.ids.map(function (id) {
            return self.remove({ type: props.type, id: id });
          })
        );
      },
    };
  }
})(window.angular);
